import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  constructor() {}

  decodeToken(token: string) {
    return jwtDecode(token);
  }

  getSubject(token: string) {
    return this.decodeToken(token).sub;
  }

  getExpiryTime(token: string): number | null {
    return this.decodeToken(token).exp || null;
  }

  isTokenExpired(token: string): boolean {
    if (!token) return true;
    const expiryTime: number | null = this.getExpiryTime(token);
    if (expiryTime) {
      return 1000 * expiryTime - new Date().getTime() < 5000;
    } else {
      return false;
    }
  }
}
